'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'index.html': {
    content: '<div id="root"></div>'
  },
  'index.tsx': {
    content: '/**\n  This CodeSandbox has been automatically generated using\n  `codesandboxer`. If you\'re curious how that happened, you can\n  check out our docs here: https://github.com/codesandbox/codesandboxer\n\n  If you experience any struggles with this sandbox, please raise an issue\n  on github. :)\n*/\nimport * as React from \'react\';\nimport * as ReactDOM from \'react-dom\';\nimport App from \'./example\';\n\nReactDOM.render(\n<App />,\ndocument.getElementById(\'root\')\n);'
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/codesandboxer/dist/templates/react-typescript.js
// module id = 432
// module chunks = 168707334958949